<template>
  <section class="page myEvaluate">
    <div class="list-wrap">
      <div v-for="(item, index) in dataList" :key="item.id" class="eva-wrap">
        <div class="cell-row content">
          {{ item.content || "您未填写评价内容" }}
        </div>
        <div class="cell-row">
          <div class="time">{{ item.createTime }}</div>
          <div class="action">
            <el-button
              type="text"
              icon="el-icon-delete"
              @click="deleteEvaluate(item.id)"
              >删除</el-button
            >
          </div>
        </div>
        <div class="goods-box">
          <div class="goods-info">
            <div class="cover-box">
              <el-image :src="item.cover"></el-image>
            </div>
            <div class="title">{{ item.resourceName }}</div>
          </div>

          <div class="rate-box">
            <el-rate
              :colors="['#D81E06', '#D81E06', '#D81E06']"
              disabled
              show-score
              disabled-void-color="#B5B5B5"
              text-color="#D81E06"
              score-template="{value}分"
              v-model="item.score"
            >
            </el-rate>
          </div>
        </div>
      </div>
      <div v-if="isEmpty">
        <no-data />
      </div>
    </div>
    <div class="pagination-box">
      <el-pagination
        class="ou-pagination"
        background
        hide-on-single-page
        @size-change="changePageSize"
        @current-change="changePageCurrent"
        :current-page="searchParams.pageNum"
        :page-sizes="[10, 15, 20, 25, 30]"
        :page-size="searchParams.pageSize"
        layout="total, prev, pager, next, sizes, jumper, slot"
        :total="total"
      >
        <el-button @click="getMyEvaluateList" class="ou-page-go">GO</el-button>
      </el-pagination>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { apiGetEvaluateList, apiDeleteEvaluate } from "@/api/user/evaluate";
import NoData from "@/components/noData.vue";
export default {
  name: "orderAppraise",
  components: { NoData },
  data() {
    return {
      detail: {},
      dataList: [],
      searchParams: {
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      appRaiseForm: [],
      appRaiseRules: {
        rate: [{ required: true, trigger: "blur", message: "请选择评分" }],
        content: [
          { required: true, trigger: "blur", message: "请输入商品评价内容" },
        ],
      },
    };
  },
  watch: {},
  computed: {
    ...mapGetters(["userId"]),
    isEmpty() {
      return !this.dataList.length;
    },
  },
  activated() {
    let { orderId } = this.$route.query;
    this.getMyEvaluateList(orderId);
  },
  mounted() {},
  methods: {
    getMyEvaluateList(orderId) {
      let { pageNum, pageSize } = this.searchParams;
      let params = { userId: this.userId, pageNum, pageSize };
      if (orderId) {
        params = { ...params, orderId };
      }
      // TODO：此处暂时用hack的方式, 通过传入订单号筛选订单列表的方式获取详情
      apiGetEvaluateList(params).then((res) => {
        let list = res.rows || [],
          dataList = [];
        list.map((item) => {
          item.score = Number(item.score).toFixed(1) - 0;
          dataList.push(item);
        });
        this.dataList = dataList;
        this.total = res.total || 0;
      });
    },
    changePageSize(val) {
      this.searchParams.pageSize = val;
      let { orderId } = this.$route.query;
      this.getMyEvaluateList();
    },
    changePageCurrent(val) {
      this.searchParams.pageNum = val;
      let { orderId } = this.$route.query;
      this.getMyEvaluateList();
    },
    deleteEvaluate(id) {
      this.$confirm(`删除后评价记录将无法找回，确定删除此评价？`, "系统提示", {
        type: "warning",
      }).then(() => {
        apiDeleteEvaluate({ id }).then((res) => {
          this.$message.success("删除评价成功");
          let { orderId } = this.$route.query;
          this.getMyEvaluateList(orderId);
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
.page.myEvaluate {
  background-color: #fffefd;
  .list-wrap::v-deep {
    padding: 0 20px;
    .eva-wrap {
      padding: 23px 0 20px;
      border-bottom: 1px solid #f2f2f2;
    }
    .cell-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      &.content {
        font-size: 14px;
        color: #333333;
        font-weight: 400;
        word-break: break-all;
      }
      .time,
      .action > .el-button--text {
        font-size: 12px;
        color: #999999;
        font-weight: 400;
      }
      .time {
        padding: 15px 0 18px;
      }
    }
    .goods-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: #f2f2f2;
      .goods-info {
        display: flex;
        align-items: center;
        .cover-box {
          padding: 4px 16px;
          .el-image {
            width: 50px;
            height: 50px;
            .el-image__error {
              font-size: 12px;
            }
          }
        }
      }

      .title {
        font-size: 14px;
        color: #666666;
      }
      .rate-box {
        justify-self: flex-end;
        padding-right: 10px;
      }
    }
  }
  .pagination-box {
    text-align: right;
    padding: 20px 30px;
  }
}
</style>
